import { Box, Card, CardContent, Skeleton, Tooltip, Typography } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import PropTypes from "prop-types";
import Iconify from "src/components/Iconify";
import {Currency} from "src/components/with-prefix";
import {fNumberCents} from "src/utils/formatNumber";

/**
 * KPI card stile "KPI Hero" della dashboard (icona squared a sx, label uppercase,
 * valore h4, sub-info opzionale). Sostituisce la vecchia Card a 2 colonne con
 * icona gigante a destra.
 */
const Cards = ({ title, color, total, icon, showCurrency, tooltip, subInfo, isLoading }) => {
  const theme = useTheme();
  const iconBg = alpha(color || theme.palette.primary.main, 0.12);
  const iconColor = color || theme.palette.primary.main;

  return (
    <Card sx={{ height: "100%" }}>
      <CardContent>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
          <Box
            sx={{
              width: 36,
              height: 36,
              borderRadius: 1,
              backgroundColor: iconBg,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <Iconify icon={icon} sx={{ color: iconColor, width: 22, height: 22 }} />
          </Box>
          {tooltip ? (
            <Tooltip title={tooltip} arrow placement="top">
              <Typography
                variant="caption"
                sx={{
                  color: "text.secondary",
                  textTransform: "uppercase",
                  letterSpacing: 0.5,
                  fontWeight: 600,
                  cursor: "help",
                }}
              >
                {title}
              </Typography>
            </Tooltip>
          ) : (
            <Typography
              variant="caption"
              sx={{
                color: "text.secondary",
                textTransform: "uppercase",
                letterSpacing: 0.5,
                fontWeight: 600,
              }}
            >
              {title}
            </Typography>
          )}
        </Box>

        <Typography variant="h4" sx={{ fontWeight: 700, mb: 0.5 }}>
          {isLoading ? (
            <Skeleton variant="text" width={120} height={40} />
          ) : showCurrency ? (
            <Currency>{fNumberCents(total ?? 0)}</Currency>
          ) : (
            fNumberCents(total ?? 0)
          )}
        </Typography>

        {subInfo && !isLoading && (
          <Typography variant="caption" color="text.secondary" sx={{ display: "block" }}>
            {subInfo}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

Cards.propTypes = {
  title: PropTypes.string.isRequired,
  total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default Cards;
